// Collection Page click JS
$(document).ready(function(){
  // $(".coll-variant-option").click(function(){
  //   var pro_id = $(this).attr('data-pro-id');
  //   var var_id = $(this).attr('data-id');
  
  //   $('.input-'+ pro_id).val(var_id);
  //   $('.variant-have-btn-'+ pro_id).trigger('click');   
  // });

   $('.owl-carousel').owlCarousel({
    loop:false,
    nav: true,
    dots: true,
    autoplay:false,
    items:1   
  });

});

//on click custom quick add

   function varclick(elem){
                   var pro_id = $(elem).attr('data-pro-id');
                    var var_id = $(elem).attr('data-id');
                  
                    $('.input-'+ pro_id).val(var_id);
                    $('.variant-have-btn-'+ pro_id).trigger('click');   
                
                
             }